import "regenerator-runtime/runtime";
import {initSlider, sliderNavigation, sliderPagination} from "./plugins/siderPlugin";
import "./plugins/tabsPlugin"
import "./plugins/yandex-map"



import FormSubmitAjaxPlugin from "../../../../plugins/beltechsoft/forms/assets/js/FormSubmitAjaxPlugin";
FormSubmitAjaxPlugin.init();


document.querySelectorAll('[data-file-custom="container"]').forEach((container) => {
    container.querySelector('[type="file"]').addEventListener('change', function( event )
    {
        const input = event.currentTarget;
        const buttonDelete = container.querySelector('[data-file-custom="delete"]');
        const name = container.querySelector('[data-file-custom="name"]');

        if(input.files.length > 0){
            let [file] = input.files;
            if(name){
                name.innerHTML = file.name
            }
            if(buttonDelete){
                buttonDelete.classList.add('-active');
                buttonDelete.addEventListener('click', (event) => {
                    name.innerHTML = '';
                    input.value = '';
                    buttonDelete.classList.remove('-active')
                })
            }
        }
    });
});

document.querySelectorAll('[data-spoiler="container"]').forEach((container) =>{
    container.querySelectorAll('[data-spoiler="button"]').forEach((button) =>{
        button.addEventListener('click', (event) => {
            container.querySelectorAll('[data-spoiler="button"]').forEach(function(button){
                button.classList.toggle('-active-button');
            });
            container.querySelector('[data-spoiler="text"]').classList.toggle('-collapse')
        })

    });
});

document.querySelectorAll('[data-faqs="container"]').forEach((container) => {
    container.querySelectorAll('[data-faqs="name"]').forEach((item) => {
        item.addEventListener('click', (event) => {
            const target = event.target;
            target.closest('[data-faqs="item"]').classList.toggle('-active');
        })
    })
});
const tariffsSearchForm = document.querySelector('[data-tariffs-search-form]');
if(tariffsSearchForm){
    document.querySelector('[data-tariffs-search-form]').addEventListener('submit', (event) => {
        event.preventDefault();

        const form = event.currentTarget;
        const formData = new FormData();

        form.querySelectorAll('input,textarea,select').forEach((control) => {
            control.classList.remove('-error');
            formData.append(control.getAttribute('name'), control.value);
        });


        fetch(form.action, {
            method: 'POST',
            headers: {
                'x-october-request-handler': form.dataset.tariffsSearchForm,
                'x-requested-with': 'XMLHttpRequest'
            },
            body: formData
        }).then((response) => {
            response.json().then((data)=> {
                if(data.status === 'errors'){
                    [...data.errors].forEach((error) => {
                        const control = form.querySelector('[name=' + error.name +']');
                        control.classList.add('-error');
                    });

                }else{
                    document.querySelector('[data-tariffs-search-form-result]').innerHTML = data.result

                }
            })
        });

    })
}

const locationPathName = window.location.pathname
if(locationPathName.includes('/news') || locationPathName.includes('/internet') || locationPathName.includes('/tv')){
    const slug = locationPathName.split("/").pop();
    const containerScroll =  document.querySelector('#'+ slug);
    if(containerScroll){
        const top = containerScroll.getBoundingClientRect().top + (containerScroll.getBoundingClientRect().height)   - (window.innerHeight>>1);
        window.scrollBy({
            top:  top,
            left: 0,
            behavior: 'smooth'
        });
    }
}

/*modal*/
document.querySelector('body').addEventListener('click', (event) => {
    const target = event.target;

    if(target instanceof HTMLElement && target.hasAttribute('data-modal')){
        const modal = document.getElementById(target.getAttribute('data-modal'));
        if(modal){
            modal.classList.add('-active');
            document.querySelector('[data-modal-background]').classList.add('-active')
        }
        event.preventDefault();
    }
    if(target instanceof HTMLElement && target.hasAttribute('data-modal-background') || target.hasAttribute('data-modal-close') ){
        document.querySelector('.modal.-active').classList.remove('-active');
        document.querySelector('[data-modal-background]').classList.remove('-active')
    }
})

/*mobile menu*/
const burger = document.querySelector('[data-mobile-menu="button"]')
if(burger){
    burger.addEventListener('click', (event) => {
       event.currentTarget.classList.toggle('-active');
       document.querySelector('[data-mobile-menu="container"]').classList.toggle('-active')
    });
}

//* scroll to faq *//
const urlHash  = window.location.hash;
if(urlHash){
   const containerScroll = document.querySelector(urlHash);
   if(containerScroll.hasAttribute('data-faqs')){
       containerScroll.dispatchEvent(new Event('click'));
       const top = containerScroll.getBoundingClientRect().top + (containerScroll.getBoundingClientRect().height)   - (window.innerHeight>>1);
       window.scrollBy({
           top:  top,
           left: 0,
           behavior: 'smooth'
       });
   }
}

/* sliders */
let sliderMainTariffType = []

const emblaNodes = document.querySelectorAll('[data-embla-container]');
emblaNodes.forEach(emblaContainer => {

    const {slider, sliderContainer} = initSlider(emblaContainer)
    sliderNavigation(slider, sliderContainer);
    sliderPagination(slider, sliderContainer);

    if(emblaContainer.hasAttribute('data-tab-content')){
        sliderMainTariffType[emblaContainer.dataset.tabContent] = slider;

    }
});

/* slider in tabs tariffs */
const mainSliderTariffs = document.querySelector('[data-main-slider-tariffs=""]');
if(mainSliderTariffs){
    mainSliderTariffs.addEventListener('click', (event) =>{
        const target = event.target;
        if(target instanceof HTMLElement && target.hasAttribute('data-tab-control')){
            const sliderTariff = sliderMainTariffType[target.dataset.tabControl]
            sliderTariff.reInit()

        }
    })
}




